import type { TFunction } from 'i18next';

import { PasswordRegex } from '../../../../shared/constants';
import yup from '../../../../shared/validation';

export function getChangePasswordFormValidation(t: TFunction) {
  return yup.object({
    currentPassword: yup
      .string()
      .required(t('formikValidation.passwordRequired')),
    password: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.passwordRequired'))
      .min(8, t('formikValidation.passwordMin'))
      .matches(PasswordRegex, t('formikValidation.passwordPattern')),
    confirmPassword: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .oneOf([yup.ref('password')], t('formikValidation.confirmPasswordMatch')),
  });
}

export function getLinkEmailFormValidation(t: TFunction) {
  return yup.object({
    password: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.passwordRequired'))
      .min(8, t('formikValidation.passwordMin'))
      .matches(PasswordRegex, t('formikValidation.passwordPattern')),
    confirmPassword: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .oneOf([yup.ref('password')], t('formikValidation.confirmPasswordMatch')),
  });
}
